// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1cg3i","range":"MonthRangeSwitch_range__2-85e","disabled":"MonthRangeSwitch_disabled__1idIN"};